"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchNormalized = exports.normalizeForSearch = void 0;
const normalizeForSearch = input => input.replaceAll(/\s+/g, ' ').toLowerCase();
exports.normalizeForSearch = normalizeForSearch;
const searchNormalized = (input, search) => (0, exports.normalizeForSearch)(input).includes((0, exports.normalizeForSearch)(search));
exports.searchNormalized = searchNormalized;
